"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var semantic_ui_react_1 = require("semantic-ui-react");
var Category_1 = require("./Category");
var Dropdown_style_1 = require("./Dropdown.style");
exports.Dropdown = function (_a) {
    var _b = _a.list, list = _b === void 0 ? [] : _b, compact = _a.compact, placeholder = _a.placeholder, disabled = _a.disabled, icon = _a.icon, color = _a.color, value = _a.value, defaultValue = _a.defaultValue, onChange = _a.onChange, onDelete = _a.onDelete;
    var hashedListRef = react_1.useRef();
    var _c = react_1.useState(), deleteIcon = _c[0], setDeleteIcon = _c[1];
    var _d = react_1.useState(), activeItem = _d[0], setActiveItem = _d[1];
    react_1.useEffect(function () {
        hashedListRef.current = hashList(list);
    }, [list]);
    react_1.useEffect(function () {
        if (value && hashedListRef.current[value]) {
            setActiveItem({ key: value, text: hashedListRef.current[value] });
        }
        if (!value || !hashedListRef.current[value]) {
            setActiveItem(undefined);
        }
    }, [value]);
    react_1.useEffect(function () {
        if (defaultValue && hashedListRef.current[defaultValue]) {
            setActiveItem({ key: defaultValue, text: hashedListRef.current[defaultValue] });
        }
    }, []);
    function hashList(list) {
        if (list === void 0) { list = []; }
        return list.reduce(function (p, c) {
            var _a;
            if (c.list)
                return __assign(__assign({}, p), hashList(c.list));
            return __assign(__assign({}, p), (_a = {}, _a[c.key] = c.text, _a));
        }, {});
    }
    function handleChange(data) {
        if (!data) {
            setActiveItem(data);
        }
        if (data) {
            setActiveItem({ key: data.value, text: data.text });
        }
        if (!onChange) {
            return;
        }
        onChange(data);
    }
    function handleDelete() {
        if (disabled) {
            return;
        }
        handleMouseOut();
        setActiveItem(undefined);
        if (!onDelete) {
            return;
        }
        onDelete();
    }
    function handleMouseOver() {
        if (disabled || !activeItem) {
            return;
        }
        setDeleteIcon("close");
    }
    function handleMouseOut() {
        if (disabled || !activeItem) {
            return;
        }
        setDeleteIcon(undefined);
    }
    return (react_1.default.createElement(Dropdown_style_1.DropdownContainer, { color: color },
        color && !icon && react_1.default.createElement(semantic_ui_react_1.Icon, { disabled: disabled, size: "small", className: "color", name: deleteIcon, onClick: handleDelete, onMouseOut: handleMouseOut, onMouseOver: handleMouseOver }),
        icon && react_1.default.createElement(semantic_ui_react_1.Icon, { name: icon }),
        react_1.default.createElement(semantic_ui_react_1.Dropdown, { compact: compact, disabled: disabled, className: "selection", placeholder: placeholder || "Select...", text: activeItem ? activeItem.text : undefined, defaultValue: activeItem ? activeItem.key : undefined },
            react_1.default.createElement(semantic_ui_react_1.Dropdown.Menu, null,
                react_1.default.createElement(Category_1.List, { list: list, activeItem: activeItem, onChange: handleChange })))));
};
//# sourceMappingURL=Dropdown.js.map